(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ol-instant-delivery"] && !Shopify.designMode) return;
  try {
    function olSyncInstantDelivery(scope) {
    if (!scope || !scope.querySelector) return;
    const field = scope.querySelector('[data-olusb-feld]');
    const postal = Boolean(field && field.checked);
    scope.querySelectorAll('[data-ol-instant-offer]').forEach((offer) => { offer.hidden = postal; });
    scope.querySelectorAll('[data-ol-delivery-fallback]').forEach((row) => { row.hidden = !postal; });
    scope.querySelectorAll('.ol-delivery-options__usb').forEach((row) => { row.classList.toggle('is-selected', postal); });
  }
  function olInitInstantDelivery() {
    document.querySelectorAll('[data-ol-instant-offer]').forEach((offer) => {
      olSyncInstantDelivery(offer.closest('.shopify-section'));
    });
  }
  document.addEventListener('change', (event) => {
    if (event.target instanceof Element && event.target.matches('[data-olusb-feld]')) {
      olSyncInstantDelivery(event.target.closest('.shopify-section'));
    }
  });
  document.addEventListener('shopify:section:load', olInitInstantDelivery);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', olInitInstantDelivery, { once: true });
  else olInitInstantDelivery();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ol-shopvote"] && !Shopify.designMode) return;
  try {
    (function () {
  const desktop = window.matchMedia('(min-width:1025px)');
  let started = false;
  function mountBadge() {
    const badge = document.getElementById('sv-rbadge-box');
    if (!badge || badge.closest('.ol-sv-dock')) return;
    const vendorLink = badge.closest('a');
    if (!vendorLink) return;
    const link = document.createElement('a');
    link.href = 'https://www.shopvote.de/bewertung_officelicense24-com_28553.html';
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    vendorLink.replaceWith(link);
    link.appendChild(badge);
    link.addEventListener('click',event => event.stopPropagation(),true);
    const dock = document.createElement('aside');
    dock.className = 'ol-sv-dock';
    dock.setAttribute('aria-label','SHOPVOTE');
    const content = document.createElement('div');
    content.className = 'ol-sv-dock__content';
    content.id = 'ol-sv-content';
    link.parentNode.insertBefore(dock,link);
    content.appendChild(link);
    dock.appendChild(content);
    for (const [property,value] of Object.entries({position:'relative',left:'0',right:'auto',top:'0',bottom:'auto','z-index':'0'})) badge.style.setProperty(property,value,'important');
    const profile = document.querySelector('.ol-siegel__feld--shopvote a');
    link.setAttribute('aria-label',profile ? profile.textContent.trim() + ' – SHOPVOTE' : 'SHOPVOTE');
    const close = document.createElement('button');
    close.type = 'button'; close.className = 'ol-sv-dock__close';
    close.innerHTML = '<span aria-hidden="true">×</span>';
    const reopen = document.createElement('button');
    reopen.type = 'button'; reopen.className = 'ol-sv-dock__tab';
    reopen.innerHTML = '<span aria-hidden="true">SHOPVOTE</span><span aria-hidden="true">›</span>';
    reopen.setAttribute('aria-controls',content.id);
    const language = document.documentElement.lang.split('-')[0];
    const labels = {
      de:['Bewertungssiegel einklappen','SHOPVOTE-Bewertungssiegel öffnen'],en:['Collapse review badge','Open SHOPVOTE review badge'],
      it:['Riduci il badge recensioni','Apri il badge recensioni SHOPVOTE'],fr:['Réduire le badge des avis','Ouvrir le badge SHOPVOTE'],
      es:['Contraer el distintivo de reseñas','Abrir el distintivo SHOPVOTE'],nl:['Beoordelingsbadge inklappen','SHOPVOTE-beoordelingsbadge openen'],
      da:['Fold anmeldelsesmærket sammen','Åbn SHOPVOTE-anmeldelsesmærket'],sv:['Fäll ihop omdömesmärket','Öppna SHOPVOTE-omdömesmärket'],
      pl:['Zwiń odznakę opinii','Otwórz odznakę opinii SHOPVOTE'],cs:['Sbalit odznak recenzí','Otevřít odznak recenzí SHOPVOTE'],
      tr:['Değerlendirme rozetini küçült','SHOPVOTE değerlendirme rozetini aç'],pt:['Recolher selo de avaliações','Abrir selo de avaliações SHOPVOTE'],
      ru:['Свернуть значок отзывов','Открыть значок отзывов SHOPVOTE'],ar:['تصغير شارة التقييمات','فتح شارة تقييمات SHOPVOTE']
    };
    const text = labels[language] || labels.en;
    close.setAttribute('aria-label',text[0]); close.setAttribute('aria-controls',content.id);
    reopen.setAttribute('aria-label',text[1]);
    dock.appendChild(close); dock.appendChild(reopen);
    function setCollapsed(collapsed,focus) {
      dock.classList.toggle('is-collapsed',collapsed);
      content.hidden = collapsed; close.hidden = collapsed; reopen.hidden = !collapsed;
      reopen.setAttribute('aria-expanded',String(!collapsed));
      if (focus) (collapsed ? reopen : close).focus({preventScroll:true});
    }
    function update(collapsed) {
      setCollapsed(collapsed,true);
      try { sessionStorage.setItem('ol-shopvote-collapsed-v2',collapsed ? '1' : '0'); sessionStorage.setItem('ol-shopvote-collapsed-v1',collapsed ? '1' : '0'); } catch (error) {}
    }
    content.addEventListener('focusin',function () {
      if (!content.hidden) badge.dispatchEvent(new MouseEvent('mouseover',{bubbles:true}));
    });
    content.addEventListener('focusout',function () {
      badge.dispatchEvent(new MouseEvent('mouseout',{bubbles:true}));
    });
    const fineHover = window.matchMedia('(hover:hover) and (pointer:fine)');
    let hoverOpened = false;
    let inhibitHover = false;
    let leaveTimer;
    function stopLeaving() { window.clearTimeout(leaveTimer); }
    function collapseAfterLeaving() {
      stopLeaving();
      leaveTimer = window.setTimeout(function () {
        const flyout = document.getElementById('sv-rbadge-box--widget');
        if (!hoverOpened || dock.matches(':hover') || dock.contains(document.activeElement) || flyout && (flyout.matches(':hover') || flyout.contains(document.activeElement))) return;
        hoverOpened = false;
        setCollapsed(true,false);
      },450);
    }
    function dismiss() {
      stopLeaving(); hoverOpened = false; inhibitHover = true; update(true);
    }
    close.addEventListener('click',function (event) { event.preventDefault(); event.stopPropagation(); dismiss(); });
    reopen.addEventListener('click',function () { stopLeaving(); hoverOpened = false; update(false); });
    dock.addEventListener('mouseenter',function () {
      stopLeaving();
      if (fineHover.matches && content.hidden && !inhibitHover) { hoverOpened = true; setCollapsed(false,false); }
    });
    dock.addEventListener('mouseleave',function () { inhibitHover = false; collapseAfterLeaving(); });
    document.addEventListener('keydown',function (event) { if (event.key === 'Escape' && !content.hidden) { event.preventDefault(); dismiss(); } });
    const flyoutLabels = {"de":["Bewertungsquellen","Bewertungsprofil öffnen","Bewertung","Bewertungen","Informationen:","Bewertungsquellen","Echtheit der Bewertungen"],"it":["Fonti delle recensioni","Vedi il profilo delle recensioni","valutazione","valutazioni","Informazioni:","fonti delle recensioni","autenticità delle recensioni"],"en":["Review sources","Show full review profile","review","reviews","Information:","review sources","authenticity of reviews"],"fr":["Sources des avis","Voir le profil des avis","avis","avis","Informations :","sources des avis","authenticité des avis"],"es":["Fuentes de las reseñas","Ver el perfil de reseñas","reseña","reseñas","Información:","fuentes de las reseñas","autenticidad de las reseñas"],"nl":["Bronnen van beoordelingen","Bekijk het beoordelingsprofiel","beoordeling","beoordelingen","Informatie:","bronnen van beoordelingen","echtheid van beoordelingen"],"pl":["Źródła opinii","Zobacz profil z opiniami","opinia","opinii","Informacje:","źródła opinii","autentyczność opinii"],"da":["Anmeldelseskilder","Se anmeldelsesprofilen","anmeldelse","anmeldelser","Information:","anmeldelseskilder","anmeldelsernes ægthed"],"sv":["Omdömeskällor","Visa omdömesprofilen","omdöme","omdömen","Information:","omdömeskällor","omdömenas äkthet"],"cs":["Zdroje recenzí","Zobrazit profil hodnocení","recenze","recenzí","Informace:","zdroje recenzí","pravost recenzí"],"tr":["Değerlendirme kaynakları","Değerlendirme profilini aç","değerlendirme","değerlendirme","Bilgi:","değerlendirme kaynakları","değerlendirmelerin gerçekliği"],"pt":["Fontes das avaliações","Ver o perfil de avaliações","avaliação","avaliações","Informações:","fontes das avaliações","autenticidade das avaliações"],"ru":["Источники отзывов","Открыть профиль отзывов","отзыв","отзывов","Информация:","источники отзывов","подлинность отзывов"],"ar":["مصادر التقييمات","عرض ملف التقييمات","تقييم","تقييمات","معلومات:","مصادر التقييمات","أصالة التقييمات"]};
    function localizeFlyout(flyout) {
      const copy = flyoutLabels[language] || flyoutLabels.en;
      const header = flyout.querySelector('.sv-fo-head-text');
      if (header) header.textContent = copy[0];
      const profileLink = flyout.querySelector('.sv-fo-footer-right a');
      if (profileLink) profileLink.textContent = copy[1]+' ↗';
      for (const row of flyout.querySelectorAll('.sv-fo-row-cstars')) {
        for (const node of [...row.childNodes]) {
          if (node.nodeType !== Node.TEXT_NODE) continue;
          const count = node.textContent.match(/\d+/);
          if (count) node.textContent = count[0]+' '+copy[Number(count[0]) === 1 ? 2 : 3];
        }
      }
      const note = flyout.querySelector('.sv-flyout-lastvote');
      const links = note ? [...note.querySelectorAll('a')] : [];
      if (links.length === 2) {
        links[0].textContent = copy[5]; links[1].textContent = copy[6];
        note.replaceChildren(document.createTextNode(copy[4]+' '),links[0],document.createTextNode(' · '),links[1]);
      }
      flyout.dir = language === 'ar' ? 'rtl' : 'ltr';
    }
    function positionFlyout() {
      const flyout = document.getElementById('sv-rbadge-box--widget');
      if (!flyout) return;
      const rect = dock.getBoundingClientRect();
      const height = flyout.offsetHeight;
      const width = flyout.offsetWidth;
      flyout.style.setProperty('position','fixed','important');
      flyout.style.setProperty('left',Math.max(12,Math.min(window.innerWidth-width-12,rect.right+12))+'px','important');
      flyout.style.setProperty('top',Math.max(12,Math.min(window.innerHeight-height-12,rect.top+rect.height/2-height/2))+'px','important');
      if (flyout.dataset.olDockReady) return;
      flyout.dataset.olDockReady = '1';
      localizeFlyout(flyout);
      flyout.setAttribute('role','region');
      const title = flyout.querySelector('.sv-fo-head-text');
      flyout.setAttribute('aria-label',title ? title.textContent.trim() : 'SHOPVOTE');
      flyout.addEventListener('mouseenter',stopLeaving);
      flyout.addEventListener('mouseleave',collapseAfterLeaving);
      flyout.addEventListener('focusin',function () { stopLeaving(); flyout.dispatchEvent(new MouseEvent('mouseover',{bubbles:true})); });
      flyout.addEventListener('focusout',collapseAfterLeaving);
    }
    const flyoutObserver = new MutationObserver(positionFlyout);
    flyoutObserver.observe(document.body,{childList:true});
    window.addEventListener('resize',positionFlyout,{passive:true});
    const compact = window.matchMedia('(max-width:1535px)');
    function rememberedCollapse() {
      try { return sessionStorage.getItem('ol-shopvote-collapsed-v2') === '1' || sessionStorage.getItem('ol-shopvote-collapsed-v1') === '1'; } catch (error) { return false; }
    }
    setCollapsed(compact.matches || rememberedCollapse(),false);
    compact.addEventListener('change',function () { setCollapsed(compact.matches || rememberedCollapse(),false); });
  }
  function initializeBadge() {
    if (started || !desktop.matches) return;
    const config = document.getElementById('ol-shopvote-config');
    if (!config) return;
    started = true;
    const observer = new MutationObserver(function () {
      if (!document.getElementById('sv-rbadge-box')) return;
      mountBadge();
      observer.disconnect();
    });
    observer.observe(document.body,{childList:true});
    function renderBadge() {
      window.myLanguage = config.dataset.language || 'en';
      if (typeof window.createRBadge === 'function') window.createRBadge(28553,1,'https',8,100,'left','top',1025);
    }
    if (typeof window.createRBadge === 'function') renderBadge();
    else {
      const script = document.createElement('script');
      script.id = 'ol-shopvote-official-script';
      script.src = 'https://widgets.shopvote.de/js/reputation-badge-v2.min.js';
      script.defer = true;
      script.addEventListener('load',renderBadge,{once:true});
      document.head.appendChild(script);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initializeBadge,{once:true});
  else initializeBadge();
  desktop.addEventListener('change',initializeBadge);
})();
  } catch(e) { console.error(e); }
})();

})();
